import {
  Tooltip,
  TooltipContent,
  TooltipProvider,
  TooltipTrigger,
} from "@/components/ui/tooltip";

export default function NavItem({
  icon,
  label,
  active,
  collapsed,
  onClick,
}) {
  const content = (
    <button
      onClick={onClick}
      aria-label={label}
      className={`flex w-full items-center rounded-xl py-3 transition-all duration-200
        ${collapsed ? "justify-center px-2" : "gap-3 px-3"}
        ${
          active
            ? "bg-[var(--fpccs-primary)] text-white shadow-[0_8px_24px_rgba(var(--fpccs-primary-rgb),0.26)]"
            : "text-[var(--fpccs-text-muted)] hover:bg-[var(--fpccs-surface-2)] hover:text-[var(--fpccs-text)]"
        }`}
    >
      {icon}
      {!collapsed && <span className="text-sm font-medium">{label}</span>}
    </button>
  );

  if (!collapsed) return content;

  return (
    <TooltipProvider delayDuration={100}>
      <Tooltip>
        <TooltipTrigger asChild>{content}</TooltipTrigger>
        <TooltipContent side="right">{label}</TooltipContent>
      </Tooltip>
    </TooltipProvider>
  );
}
